const ACCESS_TOKEN_KEY = 'csipro_access_token';

let _token = null;

export const getToken = () => {
	if (_token) return _token;

	try {
		_token = sessionStorage.getItem(ACCESS_TOKEN_KEY);
	} catch {
		_token = null;
	}

	return _token;
};

export const setToken = (token) => {
	_token = token;

	try {
		if (token) sessionStorage.setItem(ACCESS_TOKEN_KEY, token);
		else sessionStorage.removeItem(ACCESS_TOKEN_KEY);
	} catch {
		// Session storage can be unavailable in restricted browser modes.
	}
};

export const clearToken = () => {
	_token = null;

	try {
		sessionStorage.removeItem(ACCESS_TOKEN_KEY);
	} catch {
		// Session storage can be unavailable in restricted browser modes.
	}
};
